function modal() {
    hubspotForm();
    const modal = document.getElementById('hubspot-modal');
    const closeBtn = modal.querySelector('.modal-close');

    document.querySelectorAll('.subsribe-button[data-modal]').forEach(button => {
        if(button) {
            button.addEventListener('click', function () {
                modal.classList.add('open');
            });
        }

    });

    closeBtn.addEventListener('click', () => modal.classList.remove('open'));
    window.addEventListener('click', e => {
      if (e.target === modal) modal.classList.remove('open');
    });

}
function hubspotForm() {

    const formContainer = document.getElementById('hubspot-form-container');
    const subsribeButton = document.querySelector('.subsribe-button[data-modal]');

    if(subsribeButton) {
        const formId = subsribeButton.getAttribute('data-modal');
        const portalId = '22286298';

        formContainer.innerHTML = '';

        if (window.hbspt) {
            hbspt.forms.create({
                portalId: portalId,
                formId: formId,
                target: '#hubspot-form-container',

            });
        }

    }
};

